/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSouscriptionPaymentRefundQuery = gql`
  query GetSouscriptionPaymentRefundQuery {
    getSouscriptionPaymentRefund_souscription_payment_refund {
      bankAccounts {
 ownerName  
bankName  
bic  
iban  
debitDay  
debitFrequency  
type  
}
      customer {
 firstName  
lastName  
phones {
 internationalCode  
number  
isMobile  
} 
emails {
 value  
} 
bankAccounts {
 ownerName  
bankName  
bic  
iban  
} 
}
      grantees {
 id  
firstName  
type  
bankAccounts {
 ownerName  
bankName  
bic  
iban  
} 
}
      signature {
 mode  
}
      contacts {
 bankAccounts {
 ownerName  
bankName  
bic  
iban  
debitDay  
debitFrequency  
type  
} 
switch  
firstName  
lastName  
emails {
 value  
} 
phones {
 internationalCode  
number  
isMobile  
} 
}
      decisionMakerContact {
 bankAccounts {
 ownerName  
bankName  
bic  
iban  
debitDay  
debitFrequency  
type  
} 
switch  
firstName  
lastName  
emails {
 value  
} 
phones {
 internationalCode  
number  
isMobile  
} 
}
    }
  }
`;

export default GetSouscriptionPaymentRefundQuery;
